module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_26.c03b24d5.jpg";